import { Button } from '@/components'
import { RewardButtonWithState } from '@/components/molecules/rewards/RewardButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * */
export const PresentType05CouponComponents = ({
  selectedType,
  presentType,
  checkCondition,
  onStartDownload,
  onStartDownloadWithLottery,
  onGoDirectToConfirm,
  onDecideUserPresentItem,
  presentItemList,
  buttonDisabled = false,
  isApplicationForm,
  onStartApply,
  isStock,
  inPeriod,
  userRewardState,
}: PresentTypeBasedComponentsProps) => {
  const { t } = useTranslation()
  if (presentType !== 'Coupon') {
    return null
  }
  // 在庫がなくなった場合
  if (!isStock) {
    // - 特典リストを出す場合: すぐに「終了しました」を出す
    // - 特典リストを出さない場合: 特典を獲得していないければ、「終了しました」を出す。
    const skipSpecificCondition1 = userRewardState === 'RECEIVED'
    if (skipSpecificCondition1 && !presentItemList) {
      // skip: すぐに「終了しました」を出さない場合
    } else {
      return (
        <RewardButtonWithState
          inPeriod={inPeriod}
          isStock={isStock}
          checkCondition={checkCondition}
          selectedType={selectedType}
          presentType={presentType}
          isApplicationForm={isApplicationForm}
        />
      )
    }
  }
  if (!inPeriod) {
    return (
      <RewardButtonWithState
        inPeriod={inPeriod}
        isStock={isStock}
        checkCondition={checkCondition}
        selectedType={selectedType}
        presentType={presentType}
        isApplicationForm={isApplicationForm}
      />
    )
  }
  return (
    <>
      {selectedType === 1 && (
        <>
          <>
            {isApplicationForm !== 0 ? (
              <>
                <Button
                  text={
                    userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                      ? t('reward_detail.apply', '応募する')
                      : t('reward_detail.already_applied', '応募済み')
                  }
                  width="w-9/12"
                  onClick={() =>
                    userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                      ? onStartApply()
                      : onStartDownload()
                  }
                  disabled={buttonDisabled || !checkCondition}
                />
              </>
            ) : (
              <>
                {presentItemList ? (
                  <>
                    <Button
                      text={
                        userRewardState === 'CONDITION_MET' ||
                        userRewardState === 'CONDITION_NOT_MET' ||
                        userRewardState === 'RECEIVED'
                          ? t('reward_detail.coupon.use_this_coupon', 'クーポンを使用する')
                          : t('reward_detail.coupon.coupon_used', 'クーポンを使用しました')
                      }
                      width="w-9/12"
                      onClick={onStartDownload}
                      disabled={buttonDisabled || !checkCondition}
                    />
                  </>
                ) : (
                  <>
                    <Button
                      text={
                        userRewardState === 'CONDITION_MET' ||
                        userRewardState === 'CONDITION_NOT_MET' ||
                        userRewardState === 'RECEIVED'
                          ? t('reward_detail.coupon.use_this_coupon', 'クーポンを使用する')
                          : t('reward_detail.coupon.coupon_used', 'クーポンを使用しました')
                      }
                      width="w-9/12"
                      onClick={() => {
                        if (userRewardState === 'CONDITION_MET') {
                          onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                        } else if (userRewardState === 'RECEIVED') {
                          onGoDirectToConfirm({})
                        }
                      }}
                      disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
                    />
                  </>
                )}
              </>
            )}
          </>
        </>
      )}
      {selectedType === 2 && (
        <>
          <Button text={'存在しないパターン'} width="w-9/12" onClick={() => {}} disabled={true} />
        </>
      )}
      {selectedType === 3 && (
        <>
          <>
            {isApplicationForm !== 0 ? (
              <Button
                text={
                  userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                    ? t('reward_detail.lottery', '抽選する')
                    : userRewardState === 'RECEIVED'
                      ? t('reward_detail.apply', '応募する')
                      : t('reward_detail.already_applied', '応募済み')
                }
                width="w-9/12"
                onClick={() => {
                  if (userRewardState === 'CONDITION_MET') {
                    onStartDownloadWithLottery()
                  } else if (userRewardState === 'RECEIVED') {
                    onGoDirectToConfirm({})
                  }
                }}
                disabled={buttonDisabled || !checkCondition}
              />
            ) : (
              <>
                {presentItemList ? (
                  <>
                    <Button
                      text={
                        userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                          ? t('reward_detail.lottery', '抽選する')
                          : userRewardState === 'RECEIVED'
                            ? t('reward_detail.coupon.use_this_coupon', 'クーポンを使用する')
                            : t('reward_detail.coupon.coupon_used', 'クーポンを使用しました')
                      }
                      width="w-9/12"
                      onClick={onStartDownloadWithLottery}
                      disabled={buttonDisabled || !checkCondition}
                    />
                  </>
                ) : (
                  <>
                    <Button
                      text={
                        userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                          ? t('reward_detail.lottery', '抽選する')
                          : userRewardState === 'RECEIVED'
                            ? t('reward_detail.coupon.use_this_coupon', 'クーポンを使用する')
                            : t('reward_detail.coupon.coupon_used', 'クーポンを使用しました')
                      }
                      width="w-9/12"
                      onClick={() => {
                        if (userRewardState === 'RECEIVED') {
                          onGoDirectToConfirm({})
                        } else {
                          onStartDownloadWithLottery()
                        }
                      }}
                      disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
                    />
                  </>
                )}
              </>
            )}
          </>
        </>
      )}
    </>
  )
  // }
}
